import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i1946996630__a)" }, [
      _createElementVNode("path", {
        stroke: "#000",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M8.333 10.834a4.166 4.166 0 0 0 6.284.45l2.5-2.5a4.167 4.167 0 0 0-5.892-5.892L9.792 4.317m1.875 4.85a4.165 4.165 0 0 0-6.283-.45l-2.5 2.5a4.167 4.167 0 0 0 5.891 5.892l1.425-1.425"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1946996630__a" }, [
        _createElementVNode("path", {
          fill: "#000",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }